import React, { useState, useEffect, MouseEventHandler } from 'react'

import {
  Button,
  Dialog,
  Typography,
  Grid,
  Stack,
  Card,
  CardActionArea,
  CardContent,
} from '@mui/material'
import UsersEditPage from './UsersEditPage'
import { UserViewModel } from '../ViewModel'
import { getAllUsers } from '../../model'

function UsersPage() {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState('')

  const [users, setUsers] = useState([])

  useEffect(() => {
    fetchUsers()
  }, [])

  async function fetchUsers() {
    const usersData = await getAllUsers()

    setUsers(usersData)
  }

  const handleModalOpen = () => {
    setModalOpen(true)
  }

  const handleModalClose = () => {
    setModalOpen(false)
    setSelectedUserId('')
  }

  return (
    <>
      <Stack spacing={2} padding={2} flexGrow={1}>
        <Typography color="black" variant="h4">
          Users
        </Typography>
        <Button variant="contained" onClick={handleModalOpen}>
          Add new member
        </Button>
        <Grid
          container
          spacing={{ xs: 1, md: 1 }}
          justifyContent={'flex-start'}
        >
          {users.map((user, index) => (
            <Grid item xs={11} sm={5.8} md={5.8} lg={3.8} key={index}>
              <UserCard
                user={user}
                onClick={() => {
                  setSelectedUserId(user.id)
                  handleModalOpen()
                }}
              />
            </Grid>
          ))}
        </Grid>

        <Dialog open={modalOpen} onClose={handleModalClose}>
          <UsersEditPage userId={selectedUserId} onClose={handleModalClose} />
        </Dialog>
      </Stack>
    </>
  )
}

interface UserCardProps {
  user: UserViewModel
  onClick: MouseEventHandler
}

function UserCard({ user, onClick }: UserCardProps) {
  return (
    <Card>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {user.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Email: {user.email}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Phone: {user.phone}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Role: {user.role.type}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default UsersPage
